import React, { useState, useEffect } from 'react';
import { 
  Container, Box, Typography, TextField, Button, Grid, Paper, 
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  IconButton, Dialog, DialogTitle, DialogContent, DialogActions,
  Card, CardContent, Divider, Snackbar, Alert, Chip, InputAdornment,
  useMediaQuery, useTheme, List, ListItem, ListItemText, ListItemIcon,
  Avatar, Badge, Fab, Tooltip
} from '@mui/material';
import { useNavigate } from "react-router-dom";
import { API_BASE_URL, PRODUCTOSLISTS, RUTAPRODUCTOSIMAGENES, COLORSISTEMA, MESAS } from '../services/apiConfig';
import axios from 'axios';
import { 
  Add, Delete, TableRestaurant, CreditCard, Search, ArrowBack, 
  LocalBar, Storefront, TwoWheeler, Edit, Close
} from '@mui/icons-material';
import Cargando from './utils/Cargando.jsx';
import { formatCurrency } from '../utils/formatCurrency';
import { MenuInicial } from './MenuInicial';

function MesasComponent() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const userData = JSON.parse(sessionStorage.getItem("userData") || '{}');
  const sucursalid = userData?.sucursalid || 1;
  const usuarioid = userData?.usuarioid;
  
  const [mesas, setMesas] = useState([]);
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingProductos, setLoadingProductos] = useState(true);
  
  const [mesaSeleccionada, setMesaSeleccionada] = useState(null);
  const [detallesMesa, setDetallesMesa] = useState([]);
  const [mostrarHistorial, setMostrarHistorial] = useState(false);
  const [historialMesas, setHistorialMesas] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);

  const fetchHistorial = async () => {
    try {
      const response = await axios.get(API_BASE_URL + MESAS + '?sucursal_id=' + sucursalid + '&historial=1');
      if (response.data.success) {
        setHistorialMesas(response.data.data || []);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const [cobrarDialogOpen, setCobrarDialogOpen] = useState(false);
  const [cerrarDialogOpen, setCerrarDialogOpen] = useState(false);
  const [editarCantidad, setEditarCantidad] = useState(null);
  const [nuevaCantidad, setNuevaCantidad] = useState(1);
  
  const [busqueda, setBusqueda] = useState('');
  
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [metodoPago, setMetodoPago] = useState('efectivo');
  const [descuento, setDescuento] = useState(0);
  const [tipoVenta, setTipoVenta] = useState('mesa');
  const [filtroMesas, setFiltroMesas] = useState('ocupadas');

  useEffect(() => {
    fetchMesas();
    fetchProductos();
  }, []);

  const fetchMesas = async () => {
    try {
      const response = await axios.get(API_BASE_URL + MESAS + '?sucursal_id=' + sucursalid);
      if (response.data.success) {
        setMesas(response.data.data);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProductos = async () => {
    setLoadingProductos(true);
    try {
      const response = await axios.get(API_BASE_URL + PRODUCTOSLISTS);
      let prodData = [];
      if (response.data && response.data.data) {
        prodData = response.data.data;
      } else if (Array.isArray(response.data)) {
        prodData = response.data;
      }
      setProductos(prodData);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoadingProductos(false);
    }
  };

  const fetchDetallesMesa = async (mesaId) => {
    try {
      console.log('fetchDetallesMesa called with mesaId:', mesaId);
      const response = await axios.get(API_BASE_URL + MESAS + '?mesa_id=' + mesaId);
      console.log('API response:', response);
      console.log('API response.data:', response.data);
      
      if (response.data) {
        console.log('Setting detallesMesa to:', response.data.detalles);
        setDetallesMesa(response.data.detalles || []);
      } else {
        console.log('No response.data');
      }
    } catch (error) {
      console.error('Error fetchDetallesMesa:', error);
    }
  };

  const abrirMesa = (mesa) => {
    setMesaSeleccionada(mesa);
    setDetallesMesa([]);
    setMostrarHistorial(false);
    setDialogOpen(true);
    setBusqueda('');
    fetchDetallesMesa(mesa.id);
  };

  const agregarProducto = async (producto) => {
    if (!mesaSeleccionada) return;
    
    console.log('agregarProducto called with producto:', producto.nombre);
    console.log('mesaSeleccionada.id:', mesaSeleccionada.id);
    
    try {
      const response = await axios.post(API_BASE_URL + MESAS, {
        action: 'agregar_producto',
        mesa_id: mesaSeleccionada.id,
        producto_id: producto.id,
        cantidad: 1,
        precio: parseFloat(producto.precio)
      });
      
      console.log('agregarProducto response:', response.data);
      
      if (response.data.success) {
        setSnackbar({ open: true, message: '✓ ' + producto.nombre, severity: 'success' });
        console.log('Calling fetchDetallesMesa with:', mesaSeleccionada.id);
        fetchDetallesMesa(mesaSeleccionada.id);
        fetchMesas();
        setMesaSeleccionada({ ...mesaSeleccionada, estado: 'ocupada' });
      } else {
        console.log('API returned success: false');
      }
    } catch (error) {
      console.error('Error adding producto:', error);
      setSnackbar({ open: true, message: 'Error', severity: 'error' });
    }
  };

  const quitarProducto = async (detalleId) => {
    try {
      const response = await axios.post(API_BASE_URL + MESAS, {
        action: 'quitar_producto',
        detalle_id: detalleId
      });
      
      if (response.data.success) {
        setSnackbar({ open: true, message: 'Producto quitado', severity: 'success' });
        fetchDetallesMesa(mesaSeleccionada.id);
        fetchMesas();
        
        const nuevosDetalles = detallesMesa.filter(d => d.id !== detalleId);
        if (nuevosDetalles.length === 0) {
          setMesaSeleccionada({ ...mesaSeleccionada, estado: 'libre' });
        }
      }
    } catch (error) {
      setSnackbar({ open: true, message: 'Error', severity: 'error' });
    }
  };

  const actualizarCantidad = async (detalleId, nuevaCant) => {
    if (nuevaCant < 1) return;
    try {
      const response = await axios.post(API_BASE_URL + MESAS, {
        action: 'actualizar_cantidad',
        detalle_id: detalleId,
        cantidad: nuevaCant
      });
      
      if (response.data.success) {
        fetchDetallesMesa(mesaSeleccionada.id);
        fetchMesas();
      }
    } catch (error) {
      console.error('Error:', error);
    }
    setEditarCantidad(null);
  };

  const cerrarMesaSinVenta = async () => {
    if (!mesaSeleccionada) return;
    try {
      const response = await axios.post(API_BASE_URL + MESAS, {
        action: 'liberar',
        mesa_id: mesaSeleccionada.id
      });
      if (response.data.success) {
        setSnackbar({ open: true, message: 'Mesa cerrada', severity: 'success' });
        setCerrarDialogOpen(false);
        setDialogOpen(false);
        fetchMesas();
      }
    } catch (error) {
      setSnackbar({ open: true, message: 'Error', severity: 'error' });
    }
  };

  const convertirEnVenta = async () => {
    if (detallesMesa.length === 0) {
      setSnackbar({ open: true, message: 'No hay productos', severity: 'warning' });
      return;
    }
    try {
      const response = await axios.post(API_BASE_URL + MESAS, {
        action: 'cobrar',
        mesa_id: mesaSeleccionada.id,
        metodo_pago: metodoPago,
        descuento: parseFloat(descuento) || 0,
        tipo_venta: tipoVenta,
        usuario_id: usuarioid
      });
      
      if (response.data.success) {
        setSnackbar({ open: true, message: '✓ Venta #' + response.data.venta_id, severity: 'success' });
        setCobrarDialogOpen(false);
        setDialogOpen(false);
        setCerrarDialogOpen(false);
        fetchMesas();
      } else {
        setSnackbar({ open: true, message: response.data.message, severity: 'error' });
      }
    } catch (error) {
      setSnackbar({ open: true, message: 'Error', severity: 'error' });
    }
  };

  const calcularTotal = () => {
    return detallesMesa.reduce((total, d) => total + (d.cantidad * parseFloat(d.precio || 0)), 0);
  };

  const productosFiltrados = productos.filter(p => 
    p.nombre && p.nombre.toLowerCase().includes(busqueda.toLowerCase())
  );

  const getMesaColor = (estado) => {
    switch (estado) {
      case 'libre': return '#22c55e';
      case 'ocupada': return '#ef4444';
      default: return '#9ca3af';
    }
  };

  const getEstadoDisplay = (estado) => {
    switch (estado) {
      case 'libre': return 'LIBRE';
      case 'ocupada': return 'OCUPADA';
      default: return estado?.toUpperCase() || 'DESCONOCIDO';
    }
  };

  const getProductoImage = (producto) => {
    if (producto.fotos) {
      return RUTAPRODUCTOSIMAGENES + producto.fotos;
    }
    return null;
  };

  const getTipoVentaIcon = (tipo) => {
    switch (tipo) {
      case 'bar': return <LocalBar />;
      case 'delivery': return <TwoWheeler />;
      default: return <Storefront />;
    }
  };

  if (loading) return <Cargando />;

  return (
    <Container maxWidth={isMobile ? false : 'xl'} sx={{ px: isMobile ? 1 : 3 }}>
      <MenuInicial />
      
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 1 }}>
          <TableRestaurant sx={{ fontSize: 32, color: COLORSISTEMA, mr: 1.5 }} />
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#1f2937' }}>
            Mesas
          </Typography>
          <Chip label={`Suc ${sucursalid}`} size="small" sx={{ bgcolor: '#f3f4f6' }} />
        </Box>
        
        {/* Filtro de mesas */}
        <Box sx={{ mb: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {mostrarHistorial ? (
            <Button 
              size="small" 
              variant="contained"
              color="info"
              onClick={() => {
                setMostrarHistorial(false);
              }}
            >
              ← Volver a Mesas
            </Button>
          ) : (
            <>
              <Button 
                size="small" 
                variant={filtroMesas === 'todas' ? 'contained' : 'outlined'}
                onClick={() => setFiltroMesas('todas')}
              >
                Todas
              </Button>
              <Button 
                size="small" 
                variant={filtroMesas === 'ocupadas' ? 'contained' : 'outlined'}
                onClick={() => setFiltroMesas('ocupadas')}
              >
                Ocupadas
              </Button>
              <Button 
                size="small" 
                variant={filtroMesas === 'libres' ? 'contained' : 'outlined'}
                onClick={() => setFiltroMesas('libres')}
              >
                Libres
              </Button>
              <Button 
                size="small" 
                variant="outlined"
                color="info"
                onClick={() => {
                  setMostrarHistorial(true);
                  fetchHistorial();
                }}
              >
                📜 Historial
              </Button>
            </>
          )}
        </Box>
        
        {mostrarHistorial ? (
          // Vista de historial
          <Paper sx={{ p: 2, borderRadius: 3 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
              📜 Historial de Mesas - Hoy
            </Typography>
            {historialMesas.length === 0 ? (
              <Typography color="text.secondary">No hay mesas hoy</Typography>
            ) : (
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ bgcolor: '#f3f4f6' }}>
                      <TableCell sx={{ fontWeight: 700 }}>Mesa</TableCell>
                      <TableCell sx={{ fontWeight: 700 }}>Estado</TableCell>
                      <TableCell sx={{ fontWeight: 700 }}>Apertura</TableCell>
                      <TableCell sx={{ fontWeight: 700 }}>Cierre</TableCell>
                      <TableCell sx={{ fontWeight: 700 }}>Consumo</TableCell>
                      <TableCell sx={{ fontWeight: 700 }}>Atendió</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {historialMesas.map((m) => (
                      <TableRow key={m.id} hover>
                        <TableCell sx={{ fontWeight: 600 }}>#{m.numero}</TableCell>
                        <TableCell>
                          <Chip 
                            label={m.estado === 'ocupada' ? 'ABIERT.A' : 'CERRADA'} 
                            color={m.estado === 'ocupada' ? 'error' : 'success'}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          {m.fecha_ocupacion ? new Date(m.fecha_ocupacion).toLocaleTimeString('es-ES', {hour:'2-digit', minute:'2-digit'}) : '-'}
                        </TableCell>
                        <TableCell>
                          {m.fecha_liberacion ? new Date(m.fecha_liberacion).toLocaleTimeString('es-ES', {hour:'2-digit', minute:'2-digit'}) : '-'}
                        </TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>
                          {formatCurrency(m.total_consumo || m.venta_total || 0)}
                        </TableCell>
                        <TableCell>{m.vendedor || '-'}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Paper>
        ) : (
        <Grid container spacing={2}>
          {mesas.filter(m => {
            if (filtroMesas === 'todas') return true;
            if (filtroMesas === 'ocupadas') return m.estado === 'ocupada';
            if (filtroMesas === 'libres') return m.estado === 'libre';
            return true;
          }).map((mesa) => (
            <Grid item xs={4} sm={3} md={2} key={mesa.id}>
              <Paper
                elevation={mesa.estado === 'ocupada' ? 4 : 1}
                onClick={() => abrirMesa(mesa)}
                sx={{ 
                  cursor: 'pointer',
                  borderRadius: 3,
                  overflow: 'hidden',
                  transition: 'all 0.2s ease',
                  '&:hover': { 
                    transform: 'translateY(-4px)',
                    boxShadow: 6
                  }
                }}
              >
                <Box sx={{ 
                  height: 8, 
                  bgcolor: getMesaColor(mesa.estado) 
                }} />
                <CardContent sx={{ textAlign: 'center', py: 2.5, px: 1.5 }}>
                  <Typography variant="h3" sx={{ fontWeight: 800, color: '#1f2937', lineHeight: 1 }}>
                    {mesa.numero}
                  </Typography>
                  <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                    <Box sx={{ 
                      width: 8, height: 8, borderRadius: '50%', 
                      bgcolor: getMesaColor(mesa.estado)
                    }} />
                    <Typography variant="caption" sx={{ 
                      fontWeight: 600, 
                      color: mesa.estado === 'libre' ? '#22c55e' : '#ef4444',
                      textTransform: 'uppercase',
                      fontSize: '0.65rem',
                      letterSpacing: 0.5
                    }}>
                      {getEstadoDisplay(mesa.estado)}
                    </Typography>
                  </Box>
                  {mesa.total_actual > 0 && (
                    <Typography variant="body1" sx={{ mt: 1, fontWeight: 700, color: '#1f2937' }}>
                      {formatCurrency(mesa.total_actual)}
                    </Typography>
                  )}
                </CardContent>
              </Paper>
            </Grid>
          ))}
          
          {mesas.length === 0 && (
              <Grid item xs={12}>
                <Paper sx={{ p: 4, textAlign: 'center', borderRadius: 3 }}>
                  <TableRestaurant sx={{ fontSize: 48, color: '#d1d5db', mb: 2 }} />
                  <Typography color="text.secondary">
                    No hay mesas configuradas
                  </Typography>
                </Paper>
              </Grid>
            )}
          </Grid>
        )}
      </Box>

      <Dialog 
        open={dialogOpen} 
        onClose={() => setDialogOpen(false)} 
        maxWidth="md" 
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle sx={{ 
          bgcolor: COLORSISTEMA, 
          color: 'white',
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          py: 1.5
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton onClick={() => setDialogOpen(false)} sx={{ color: 'white' }}>
              <ArrowBack />
            </IconButton>
            <Typography variant="h6" sx={{ fontWeight: 700, ml: 1 }}>
              Mesa #{mesaSeleccionada?.numero}
            </Typography>
          </Box>
          <Chip 
            label={getEstadoDisplay(mesaSeleccionada?.estado)} 
            sx={{ 
              bgcolor: mesaSeleccionada?.estado === 'libre' ? '#22c55e' : '#ef4444',
              color: 'white',
              fontWeight: 700
            }} 
          />
        </DialogTitle>
        
        <DialogContent sx={{ p: 0 }}>
          <Grid container sx={{ minHeight: 450 }}>
            {/* Productos - Izquierda */}
            <Grid item xs={12} md={5.5} sx={{ borderRight: '1px solid #e5e7eb', p: 2.5, bgcolor: '#fafafa' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: '#374151' }}>
                📋 Menú
              </Typography>
              <TextField
                fullWidth
                size="small"
                placeholder="Buscar producto..."
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
                sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><Search /></InputAdornment>,
                }}
              />
              
              <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                {loadingProductos ? (
                  <Cargando />
                ) : (
                  <>
                    {productosFiltrados.slice(0, 12).map((producto) => (
                      <Paper
                        key={producto.id}
                        elevation={0}
                        onClick={() => agregarProducto(producto)}
                        sx={{ 
                          mb: 1, p: 1.5, borderRadius: 2, 
                          cursor: 'pointer', 
                          display: 'flex', alignItems: 'center',
                          bgcolor: 'white', border: '1px solid #e5e7eb',
                          transition: 'all 0.15s',
                          '&:hover': { 
                            bgcolor: COLORSISTEMA, 
                            borderColor: COLORSISTEMA,
                            '& .producto-nombre, & .producto-precio': { color: 'white' }
                          }
                        }}
                      >
                        {producto.fotos && (
                          <Avatar 
                            src={getProductoImage(producto)}
                            variant="rounded"
                            sx={{ width: 40, height: 40, mr: 1.5 }}
                          />
                        )}
                        <Box sx={{ flex: 1 }}>
                          <Typography 
                            className="producto-nombre"
                            variant="body2" 
                            sx={{ fontWeight: 600, color: '#1f2937' }}
                          >
                            {producto.nombre}
                          </Typography>
                          <Typography 
                            className="producto-precio"
                            variant="caption" 
                            sx={{ color: COLORSISTEMA, fontWeight: 700 }}
                          >
                            {formatCurrency(parseFloat(producto.precio || 0))}
                          </Typography>
                        </Box>
                        <Fab size="small" color="primary" sx={{ width: 28, height: 28 }}>
                          <Add sx={{ fontSize: 18 }} />
                        </Fab>
                      </Paper>
                    ))}
                  </>
                )}
              </Box>
            </Grid>
            
            {/* Pedido - Derecha */}
            <Grid item xs={12} md={6.5} sx={{ p: 2.5 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#374151' }}>
                  🧾 Pedido
                </Typography>
                <Badge badgeContent={detallesMesa.length} color="primary" />
              </Box>
              
              {detallesMesa.length === 0 ? (
                <Paper sx={{ p: 4, textAlign: 'center', borderRadius: 2, bgcolor: '#f9fafb' }}>
                  <Typography color="text.secondary" sx={{ fontSize: '0.9rem' }}>
                    {mesaSeleccionada?.estado === 'libre' 
                      ? 'Mesa cerrada - Ver historial' 
                      : 'Tocá un producto para agregar'}
                  </Typography>
                </Paper>
              ) : (
                <>
                  <TableContainer>
                    <Table size="small">
                      <TableBody>
                        {detallesMesa.map((detalle) => (
                          <TableRow 
                            key={detalle.id}
                            sx={{ '&:last-child td': { border: 0 } }}
                          >
                            <TableCell sx={{ py: 1.5, px: 1, width: 50 }}>
                              {editarCantidad === detalle.id ? (
                                <TextField
                                  type="number"
                                  size="small"
                                  value={nuevaCantidad}
                                  onChange={(e) => setNuevaCantidad(parseInt(e.target.value) || 1)}
                                  onBlur={() => actualizarCantidad(detalle.id, nuevaCantidad)}
                                  onKeyDown={(e) => e.key === 'Enter' && actualizarCantidad(detalle.id, nuevaCantidad)}
                                  autoFocus
                                  sx={{ width: 55 }}
                                  inputProps={{ style: { textAlign: 'center' } }}
                                />
                              ) : (
                                <Typography 
                                  sx={{ 
                                    cursor: 'pointer', 
                                    fontWeight: 700, 
                                    px: 1, py: 0.5,
                                    borderRadius: 1,
                                    bgcolor: '#f3f4f6',
                                    display: 'inline-block',
                                    '&:hover': { bgcolor: '#e5e7eb' }
                                  }}
                                  onClick={() => { setEditarCantidad(detalle.id); setNuevaCantidad(detalle.cantidad); }}
                                >
                                  {detalle.cantidad}×
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell sx={{ py: 1.5 }}>
                              {detalle.producto_nombre || 'P' + detalle.producto_id}
                            </TableCell>
                            <TableCell align="right" sx={{ py: 1.5, fontWeight: 600 }}>
                              {formatCurrency(parseFloat(detalle.precio || 0) * detalle.cantidad)}
                            </TableCell>
                            <TableCell align="right" sx={{ py: 1.5, width: 40 }}>
                              <IconButton 
                                size="small" 
                                color="error"
                                onClick={() => quitarProducto(detalle.id)}
                                sx={{ '&:hover': { bgcolor: '#fee2e2' } }}
                              >
                                <Delete fontSize="small" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  
                  <Divider sx={{ my: 2 }} />
                  
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="body2" color="text.secondary">Subtotal</Typography>
                    <Typography variant="body2">{formatCurrency(calcularTotal())}</Typography>
                  </Box>
                  
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 700 }}>Total</Typography>
                    <Typography variant="h5" sx={{ fontWeight: 800, color: COLORSISTEMA }}>
                      {formatCurrency(calcularTotal())}
                    </Typography>
                  </Box>
                  
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Button 
                        variant="contained" 
                        fullWidth
                        size="large"
                        startIcon={<CreditCard />}
                        onClick={() => { setCobrarDialogOpen(true); setCerrarDialogOpen(true); }}
                        sx={{ 
                          bgcolor: '#22c55e',
                          fontWeight: 700,
                          py: 1.5,
                          '&:hover': { bgcolor: '#16a34a' }
                        }}
                      >
                        COBRAR
                      </Button>
                    </Grid>
                    <Grid item xs={6}>
                      <Button 
                        variant="outlined" 
                        fullWidth
                        size="large"
                        onClick={() => setCerrarDialogOpen(true)}
                        sx={{ 
                          borderColor: '#ef4444',
                          color: '#ef4444',
                          fontWeight: 700,
                          py: 1.5,
                          '&:hover': { bgcolor: '#fef2f2', borderColor: '#ef4444' }
                        }}
                      >
                        Cerrar
                      </Button>
                    </Grid>
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* Dialog Cerrar Mesa */}
      <Dialog open={cerrarDialogOpen} onClose={() => setCerrarDialogOpen(false)} PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ fontWeight: 700 }}>¿Qué hacés con la Mesa #{mesaSeleccionada?.numero}?</DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {detallesMesa.length} producto(s) — {formatCurrency(calcularTotal())}
          </Typography>
          
          {detallesMesa.length > 0 && (
            <>
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>Tipo de venta:</Typography>
              <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                <Chip 
                  icon={<LocalBar />}
                  label="Bar"
                  onClick={() => setTipoVenta('bar')}
                  color={tipoVenta === 'bar' ? 'primary' : 'default'}
                  sx={{ flex: 1, justifyContent: 'flex-start', pl: 1 }}
                />
                <Chip 
                  icon={<Storefront />}
                  label="Mostrador"
                  onClick={() => setTipoVenta('mostrador')}
                  color={tipoVenta === 'mostrador' ? 'primary' : 'default'}
                  sx={{ flex: 1, justifyContent: 'flex-start', pl: 1 }}
                />
                <Chip 
                  icon={<TwoWheeler />}
                  label="Delivery"
                  onClick={() => setTipoVenta('delivery')}
                  color={tipoVenta === 'delivery' ? 'primary' : 'default'}
                  sx={{ flex: 1, justifyContent: 'flex-start', pl: 1 }}
                />
              </Box>
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button onClick={() => setCerrarDialogOpen(false)}>Cancelar</Button>
          {detallesMesa.length > 0 && (
            <Button 
              variant="contained" 
              color="success" 
              onClick={() => { setCobrarDialogOpen(true); }}
            >
              Cobrar y Cerrar
            </Button>
          )}
          <Button 
            variant="outlined" 
            color="error" 
            onClick={cerrarMesaSinVenta}
          >
            Cerrar sin cobrar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Cobrar */}
      <Dialog open={cobrarDialogOpen} onClose={() => setCobrarDialogOpen(false)} PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ fontWeight: 700, textAlign: 'center', pt: 3 }}>
          Cobrar Mesa #{mesaSeleccionada?.numero}
        </DialogTitle>
        <DialogContent>
          <Typography variant="h3" align="center" sx={{ my: 2, fontWeight: 800, color: COLORSISTEMA }}>
            {formatCurrency(calcularTotal())}
          </Typography>
          
          <TextField
            fullWidth
            label="Descuento ($)"
            type="number"
            value={descuento}
            onChange={(e) => setDescuento(e.target.value)}
            sx={{ mb: 3 }}
          />
          
          <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>Método de pago:</Typography>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
            {[
              { v: 'efectivo', l: '💵 Efectivo' },
              { v: 'debito', l: '💳 Débito' },
              { v: 'credito', l: '💳 Crédito' },
              { v: 'transferencia', l: '🏦 Transferencia' }
            ].map((m) => (
              <Chip 
                key={m.v}
                label={m.l}
                onClick={() => setMetodoPago(m.v)}
                color={metodoPago === m.v ? 'primary' : 'default'}
                sx={{ flex: '1 1 45%' }}
              />
            ))}
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 0 }}>
          <Button onClick={() => setCobrarDialogOpen(false)}>Cancelar</Button>
          <Button 
            variant="contained" 
            color="primary" 
            size="large"
            onClick={convertirEnVenta}
            sx={{ px: 4, fontWeight: 700 }}
          >
            Confirmar Venta
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={2500} 
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity={snackbar.severity} sx={{ borderRadius: 2, fontWeight: 600 }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}

export default MesasComponent;